// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationGroupId } from './FermentationGroup';
import { fermentationId } from './Fermentation';
import { brewcontrolNodeId } from './BrewcontrolNode';
import { brewcontrolRunId } from './BrewcontrolRun';
import { z } from 'zod';
export const fermentationTimeseriesRecordingId = (z.number());
export const fermentationTimeseriesRecording = z.object({
    id: fermentationTimeseriesRecordingId,
    fermentation_group_id: fermentationGroupId,
    fermentation_id: fermentationId.nullable(),
    equipment_type: z.string(),
    started_at: z.date().nullable(),
    ended_at: z.date().nullable(),
    raw_file_path: z.string().nullable(),
    source_type: z.string(),
    created_at: z.date().nullable(),
    is_live: z.boolean().nullable(),
    brewcontrol_node_id: brewcontrolNodeId.nullable(),
    brewcontrol_run_id: brewcontrolRunId.nullable(),
    followed_seq: z.string(),
});
export const fermentationTimeseriesRecordingInitializer = z.object({
    id: fermentationTimeseriesRecordingId.optional(),
    fermentation_group_id: fermentationGroupId,
    fermentation_id: fermentationId.optional().nullable(),
    equipment_type: z.string(),
    started_at: z.date().optional().nullable(),
    ended_at: z.date().optional().nullable(),
    raw_file_path: z.string().optional().nullable(),
    source_type: z.string().optional(),
    created_at: z.date().optional().nullable(),
    is_live: z.boolean().optional().nullable(),
    brewcontrol_node_id: brewcontrolNodeId.optional().nullable(),
    brewcontrol_run_id: brewcontrolRunId.optional().nullable(),
    followed_seq: z.string().optional(),
});
export const fermentationTimeseriesRecordingMutator = z.object({
    id: fermentationTimeseriesRecordingId.optional(),
    fermentation_group_id: fermentationGroupId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    equipment_type: z.string().optional(),
    started_at: z.date().optional().nullable(),
    ended_at: z.date().optional().nullable(),
    raw_file_path: z.string().optional().nullable(),
    source_type: z.string().optional(),
    created_at: z.date().optional().nullable(),
    is_live: z.boolean().optional().nullable(),
    brewcontrol_node_id: brewcontrolNodeId.optional().nullable(),
    brewcontrol_run_id: brewcontrolRunId.optional().nullable(),
    followed_seq: z.string().optional(),
});
//# sourceMappingURL=FermentationTimeseriesRecording.js.map